/**
 * Command Palette Store
 *
 * Zustand store for controlling the command palette dialog
 * and any setup dialogs triggered by commands.
 */

import { create } from 'zustand';

export type PendingDialog = 'schema-compare' | 'data-compare' | 'table-designer';
export type CommandPalettePage = 'main' | 'query-history';

type TableDesignerContext = {
  connectionId: string;
  database: string;
};

type CommandPaletteState = {
  isOpen: boolean;
  /** Initial page to show when palette opens (resets to 'main' on close) */
  initialPage: CommandPalettePage;
  pendingDialog: PendingDialog | null;
  tableDesignerContext: TableDesignerContext | null;

  open: () => void;
  close: () => void;
  toggle: () => void;
  /** Open palette directly on a specific page */
  openPage: (page: CommandPalettePage) => void;
  setPendingDialog: (dialog: PendingDialog | null) => void;
  openTableDesigner: (ctx: TableDesignerContext) => void;
  clearPendingDialog: () => void;
};

export const useCommandPaletteStore = create<CommandPaletteState>((set) => ({
  isOpen: false,
  initialPage: 'main',
  pendingDialog: null,
  tableDesignerContext: null,

  open: () => set({ isOpen: true, initialPage: 'main' }),
  close: () => set({ isOpen: false, initialPage: 'main' }),
  toggle: () => set((s) => ({ isOpen: !s.isOpen, initialPage: s.isOpen ? 'main' : s.initialPage })),
  openPage: (page) => set({ isOpen: true, initialPage: page }),
  setPendingDialog: (dialog) => set({ pendingDialog: dialog }),
  openTableDesigner: (ctx) => set({ pendingDialog: 'table-designer', tableDesignerContext: ctx }),
  clearPendingDialog: () => set({ pendingDialog: null, tableDesignerContext: null }),
}));
